module.exports = __webpack_public_path__ + "static/img/mork_img.5a4b4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mystery-box-center/mork_img.png
// module id = g7gd
// module chunks = 215